import { render, staticRenderFns } from "./BannerSetting.vue?vue&type=template&id=45db8a5e"
import script from "./BannerSetting.vue?vue&type=script&lang=js"
export * from "./BannerSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports